import * as React from "react";
import type { SVGProps } from "react";
import { Ref, forwardRef } from "react";
const SvgFile = (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => <svg viewBox="0 0 16 16" role="img" ref={ref} {...props}><path fill="currentColor" d="M13.2 5.6H8.8V1.2zM8.938 0H3.2a1.6 1.6 0 0 0-1.6 1.6v12.8A1.6 1.6 0 0 0 3.2 16h9.6a1.6 1.6 0 0 0 1.6-1.6V5.462a1.6 1.6 0 0 0-.469-1.131L10.069.469A1.6 1.6 0 0 0 8.938 0z" /></svg>;
const ForwardRef = forwardRef(SvgFile);
export default ForwardRef;